<template>
  <div id="app">
    <router-view></router-view>
    <ConsentFooter />
  </div>
</template>
<script>
  // 2.0兼容IE
  import 'babel-polyfill'

  import api from '../src/api/account.js'
  import auth from './utils/auth'
  import {setSlotsFaviconFromRedirect} from './utils/favicon'
  import {mapMutations} from 'vuex'
  import ConsentFooter from './components/ConsentFooter.vue'

  const FALLTHROUGH_PATHS_PATTERN = /\/(reset|password|login).*/i

  export default {
    name: 'app',
    components: {
      ConsentFooter
    },
    data () {
      return {}
    },
    methods: {

      ...mapMutations([
        'loggingStatus',
        'testPlatform',
        'checkIP'
      ]),

      getCookies () {
        let currentPath = this.$router.currentRoute.path;
        if (!FALLTHROUGH_PATHS_PATTERN.test(currentPath)) {
          let userEmail = auth.getCookie('userEmail');
          let nextHop;
          if (userEmail) {
            nextHop = userEmail === 'facebook' ? '/login#facebook' : '/login'
          } else {
            nextHop = '/signup'
          }
          this.$router.push(nextHop)
        } else {
          // do nothing to fallthrough
        }
      },
      checkUrl () {
        if (!location.href.includes('direct')) {
          this.getCookies()
        }
      },
      preventDefaults () {
        document.addEventListener('mousemove', (e) => {
          e.preventDefault()
        }, false)
      },
      showLoginFailAlert(){
        var r=null;
        if (location.href.includes('accountExist')) {
          let userEmail = auth.getCookie('userEmail');
          if (userEmail) {
            if(location.href.includes('playpokergo')){
              r = confirm("Your account is associated with PokerAllDay. Please log in on PokerAllDay.")
            } else {
              r = confirm("Your account is associated with PlayPokerGo. Please log in on PlayPokerGo.")
            }
            
          } else {
            if(location.href.includes('playpokergo')){
              r = confirm("You already have an account on the CaptivePlay Network. Please log into your account on PokerAllDay.")
            } else {
              r = confirm("You already have an account on the CaptiveGo Network. Please log into your account on PlayPokerGo.")
            }
        
          }
          
        }

        if(r==null)
        return;

        if (r == true) {
          if(!location.href.includes('playpokergo')){
            window.location.href = 'https://accounts.playpokergo.com/#/login'
          }else{
            window.location.href = 'https://accounts.pokerallday.com/#/login'
          }
        } 
      }
    },
    mounted () {
      setSlotsFaviconFromRedirect()
      this.testPlatform()
      this.checkIP()
      api.getToken({version: Math.random()})
      this.checkUrl()
      this.loggingStatus()
      this.preventDefaults()
      this.showLoginFailAlert()
    }
  }
</script>
<style>
  html, body {
    width: 100%;
    height: 100%;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue